module.exports = __webpack_public_path__ + "img/x1.b2d649b5.jpg";